import { render, staticRenderFns } from "./CompanyEdit_backup20220916.vue?vue&type=template&id=20c08414&scoped=true&"
import script from "./CompanyEdit_backup20220916.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit_backup20220916.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c08414",
  null
  
)

export default component.exports